import React from "react";
import { useTranslation } from "react-i18next";
import RadioInput from "../inputs/radioInput";
import "../../styles/customer-details.scss";
import GooglePay from "../../assets/icons/google_pay.svg";
import ApplePay from "../../assets/icons/apple_pay.svg";
import { assetUrl } from "../../utils/assetUrl";

interface PaymentMethodProps {
  selectedPaymentMethod: string;
  onSelect: (method: string) => void;
  showApplePay: boolean;
  showGooglePay: boolean;
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  selectedPaymentMethod,
  onSelect,
  showApplePay,
  showGooglePay,
}) => {
  const { t } = useTranslation();

  return (
    <div className="gcw:flex gcw:flex-col">
      <RadioInput
        id="card"
        name="type"
        value="card"
        checked={selectedPaymentMethod === "card"}
        onChange={() => onSelect("card")}
        className={selectedPaymentMethod === "card" ? "checked gcw:w-full" : "gcw:w-full"}
        label={
          <>
            <span className="gcw:flex gcw:items-center gcw:ps-2 gcw:pe-2">
              <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                className="payment-method-icon"
                aria-hidden="true"
                focusable="false"
              >
                <path
                  d="M4.75 4.5C2.96403 4.5 1.5 5.96403 1.5 7.75V16.25C1.5 18.036 2.96403 19.5 4.75 19.5H20.25C22.036 19.5 23.5 18.036 23.5 16.25V7.75C23.5 5.96403 22.036 4.5 20.25 4.5H4.75ZM4.75 6H20.25C21.225 6 22 6.77497 22 7.75V8.5H3V7.75C3 6.77497 3.77497 6 4.75 6ZM3 10.5H22V16.25C22 17.225 21.225 18 20.25 18H4.75C3.77497 18 3 17.225 3 16.25V10.5ZM16.25 14.5C16.1506 14.4986 16.0519 14.517 15.9597 14.554C15.8675 14.5911 15.7836 14.6461 15.7128 14.7159C15.642 14.7857 15.5858 14.8688 15.5474 14.9605C15.5091 15.0522 15.4893 15.1506 15.4893 15.25C15.4893 15.3494 15.5091 15.4478 15.5474 15.5395C15.5858 15.6312 15.642 15.7143 15.7128 15.7841C15.7836 15.8539 15.8675 15.9089 15.9597 15.946C16.0519 15.983 16.1506 16.0014 16.25 16H19.25C19.3494 16.0014 19.4481 15.983 19.5403 15.946C19.6325 15.9089 19.7164 15.8539 19.7872 15.7841C19.858 15.7143 19.9142 15.6312 19.9526 15.5395C19.9909 15.4478 20.0107 15.3494 20.0107 15.25C20.0107 15.1506 19.9909 15.0522 19.9526 14.9605C19.9142 14.8688 19.858 14.7857 19.7872 14.7159C19.7164 14.6461 19.6325 14.5911 19.5403 14.554C19.4481 14.517 19.3494 14.4986 19.25 14.5H16.25Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span className="label-info">{t("debit_credit_card", "Debit / Credit Card")}</span>
          </>
        }
      />
      {showApplePay && (
        <RadioInput
          id="apple_pay"
          name="type"
          value="apple_pay"
          checked={selectedPaymentMethod === "apple_pay"}
          onChange={() => onSelect("apple_pay")}
          className={selectedPaymentMethod === "apple_pay" ? "checked" : ""}
          label={
            <>
              <span className="gcw:flex gcw:items-center gcw:ps-2 gcw:pe-2">
                <img src={assetUrl(ApplePay)} alt="Apple Pay Icon" className="apple-pay-icon" />
              </span>
              <span className="label-info">{t("apple_pay", "Apple Pay")}</span>
            </>
          }
        />
      )}
      {showGooglePay && (
        <RadioInput
          id="google_pay"
          name="type"
          value="google_pay"
          checked={selectedPaymentMethod === "google_pay"}
          onChange={() => onSelect("google_pay")}
          className={selectedPaymentMethod === "google_pay" ? "checked" : ""}
          label={
            <>
              <span className="gcw:flex gcw:items-center gcw:ps-2 gcw:pe-2">
                <img src={assetUrl(GooglePay)} alt="GooglePay Icon" />
              </span>
              <span className="label-info">{t("google_pay", "Google Pay")}</span>
            </>
          }
        />
      )}
    </div>
  );
};

export default PaymentMethod;
